// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat___Gruf","inputDescription":"styles_inputDescription__k_JqE"};